import React, {useContext, useEffect} from "react";
import OtpInput from "Standard/components/OTPInput";
import Text from "components/Text";
import styled from "styled-components";
import ErrorMessage from "components/ErrorMessage";
import {useNavigate} from "react-router-dom";
import useValidatedState, {validationFuncs} from "Standard/hooks/useValidatedState";
import {useSendCode} from "hooks/useSendCode";
import {RouteName} from "router";
import LocaleContext from "../../Standard/LocaleContext";
import {localized} from "../../Standard/utils/localized";
import texts from "./localization"

type TwoFAPropType = {
  setIsWaitingForCode: (value: boolean) => void,
  appUrl?: string,
  isWaitingForCode: boolean
  email: string,
  serverUrl: string
}

const TwoFADefaultProps = {};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 48px;
`

const TwoFAContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  border: 1px solid rgba(24, 24, 51, 0.1);
  border-radius: 16px;
  padding: 50px 45px;
  width: 480px;
  margin-bottom: 20px;
  /* z-index: 1000; */
  z-index: 1;

  @media (max-width: 768px) {
    padding: 30px 15px;
    width: 100%;
  }
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const ReturnButton = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #D2D5DA;
  margin-top: 23px;
  cursor: pointer;
`

const TitleText = styled.div`
  font-weight: 600;
  font-size: 25px;

  @media (max-width: 640px) {
    font-size: 22px;
  }

`
const TwoFA = (props: TwoFAPropType) => {
  const {locale} = useContext(LocaleContext);


  const {setIsWaitingForCode, appUrl, isWaitingForCode, email, serverUrl} = props

  const [[code, setCode], codeValid] = useValidatedState<string>("", validationFuncs.hasValue);

  const history = useNavigate()

  const handleReturnButtonClick = () => {
    setIsWaitingForCode(false)
    setCode("")

    if (appUrl) {
      history(appUrl)
    }
  }

  const {fetchCode, incorrectCodeError} = useSendCode(
    {
      login: email,
      mfaCode: +code
    },
    serverUrl,
    appUrl
  )

  async function sendCode() {
    if (!codeValid) return
    fetchCode()
  }

  useEffect(() => {
    if (isWaitingForCode && code.length === 4) {
      sendCode()
    }
  }, [isWaitingForCode, code])


  return (
    <Container>
      <TwoFAContainer>
        <TextWrapper>
          <TitleText >{localized(texts["twoFactorAuthentication"], locale)}</TitleText>
          <Text fontWeight={400} fontSize={16} marginBottom={25}>{localized(texts.messageSend, locale)}</Text>
        </TextWrapper>
        <OtpInput value={code} valueLength={4} onChange={setCode}/>
        <ReturnButton onClick={handleReturnButtonClick}>{localized(texts.cancel, locale)}</ReturnButton>
      </TwoFAContainer>
      {
        incorrectCodeError &&
        <ErrorMessage
          message={incorrectCodeError}
          title={localized(texts.error2FA, locale)}
        />
      }
    </Container>
  );
};

TwoFA.defaultProps = TwoFADefaultProps;

export default TwoFA;

